"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Spin](https://docs.vanillaframework.io/settings/animation-settings/#spin) animation.
 */
const Spinner = _ref => {
  let {
    className,
    text,
    isLight = false,
    ariaLive = "polite",
    role = "alert",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("span", _extends({}, props, {
    className: (0, _classnames.default)(className, "p-text--default"),
    role: role,
    "aria-live": ariaLive
  }), /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)("p-icon--spinner", "u-animation--spin", {
      "is-light": isLight
    })
  }, text ? "" : "Loading"), text && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\u2002", /*#__PURE__*/_react.default.createElement("span", null, text)));
};
Spinner.propTypes = {
  isLight: _propTypes.default.bool,
  text: _propTypes.default.string,
  role: _propTypes.default.string,
  ariaLive: _propTypes.default.oneOf(["assertive", "off", "polite"])
};
var _default = exports.default = Spinner;